import React, {PureComponent} from 'react'
import { connect } from 'react-redux'

import Modalizer from 'components/modalizer/modalizer'
import adminOnboardingActions from 'redux/actions/adminOnboardingActions'
import AdminOnboardingLearnMoreForm from 'views/admin_onboarding/refer_contact/form/admin_onboarding_refer_contact_form'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { adminOnboardingSelectors } from 'redux/selectors'

class ReferContactModal extends PureComponent {

	render() {
		return (
			<Modalizer modalName={this.props.modalName} width='500px' closeAction={this.props.actions.closeReferAContactModal}>
				<AdminOnboardingLearnMoreForm
					sendEmailToDM = {this.props.actions.sendEmailToDM}
					isTrialFromSF = {this.props.isTrialFromSF}
				/>
			</Modalizer>
		)
	}

}

function mapStateToProps(state) {
	return adminOnboardingSelectors.getAdminOnboardingIsTrialFromSF(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeReferAContactModal: adminOnboardingActions.closeReferAContactModal,
		sendEmailToDM: adminOnboardingActions.sendEmailToDM,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferContactModal)
